import { z } from 'zod';

const OccupancyDailyDataV4Schema = z.object({
    date: z.string(),
    room_type_id: z.string().nullable(),
    occupancy: z.string(),
    total_booked: z.coerce.number(),
    total_rooms: z.coerce.number(),
    available: z.coerce.number(),
});

const OccupancyDailyResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(OccupancyDailyDataV4Schema),
});

export { OccupancyDailyResponseV4Schema, OccupancyDailyDataV4Schema };
export type OccupancyDailyResponseV4 = z.infer<typeof OccupancyDailyResponseV4Schema>;
export type OccupancyDailyDataV4 = z.infer<typeof OccupancyDailyDataV4Schema>;
